// Copyright (c) Hamilton Manufacturing Corp.
import React from 'react';
import { Navigate } from 'react-router-dom';
import styled from 'styled-components';
import AccountForm from '../../_common/AccountForm';
import { useGlobalState } from '../../_common/globalState/GlobalStateProvider';
import Card from '../Card';
import Button from '../../_common/form/Button';

const Wrapper = styled.div`
`
const Col = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`

const SignUp = ({ ...props }) => {
    const {
        state: {
            active_user,
        },
    } = useGlobalState();

    if (active_user.isLoggedIn) {
        return <Navigate to='/' replace />;
    }

    return (
        <Wrapper>
            <Card>
                <Col>
                    <span>Welcome!</span>
                    <span>Please complete the following fields</span>
                </Col>
                <AccountForm password referral signup fullWidthSubmit />
                <Button to='/'>Go Back</Button>
            </Card>
        </Wrapper>
    );
}

export default SignUp;